module.exports = __webpack_public_path__ + "img/brand/evi-logo-positive.svg";